import createClient from "openapi-react-query";

import { QueryClient } from "@tanstack/react-query";

import {
  createOpenApiClient,
  Middleware,
} from "@/providers/smarta-documents/documents-api-client";
import { getConfig } from "@/v1/config";
import { tokenStorage } from "../../auth";

export const baseUrl = `${getConfig("VITE_APP_API_URL")}/api/kontax/documents`;

const middleware: Middleware = {
  onRequest: async ({ request }) => {
    const token = tokenStorage.getToken();
    if (!token) {
      throw new Error("Authentication token is required");
    }
    request.headers.set("X-Auth-Token", token);
    return request;
  },
};

export const client = createOpenApiClient({
  baseUrl,
});
client.use(middleware);

export const queryClient = new QueryClient();

export const api = createClient(client);
